module.exports = __webpack_public_path__ + "img/feature_buy_en.e4a7daa7.png";